export const BUTTONS_VARIANTS = {
  highlighted: 'highlighted',
  floating: 'floating',
  default: 'default',
};
